import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userinfo: {},
  isAuthenticated: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.userinfo = action.payload;
      state.isAuthenticated = true;
    },
    setLogout: (state) => {
      state.userinfo = {};
      state.isAuthenticated = false;
    },
    setUserInfo: (state, action) => {
      state.userinfo = action.payload;
    },
  },
});

export const { login, setLogout, setUserInfo } = userSlice.actions;

export default userSlice.reducer;
